module.exports = __webpack_public_path__ + "img/54.a53419f8.png";